/**
 * A conversation the user asked to delete, waiting for confirmation.
 *
 * The request is raised from the conversation list's row menu (`ui-workspace`'s menu, where Orik registers a
 * Delete entry in `harness/orik-harness.ts`), which closes as soon as an entry is chosen; the confirmation
 * lives in Orik's sidebar, outside the menu, and reads the request from here.
 */
import { create } from "zustand";

export interface DeleteRequest {
  readonly sessionId: string;
  readonly title: string;
}

export const useDeleteConversation = create<{
  pending?: DeleteRequest | undefined;
  request(pending: DeleteRequest): void;
  clear(): void;
}>(set => ({
  request: pending => set({ pending }),
  clear: () => set({ pending: undefined }),
}));
